import { ICountryMySuffix } from "./country-my-suffix.model";

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface IAddressMySuffix {
    addressCountry?: any;
    id?: number;
    streetAddress?: string;
    addressLine?: string;
    city?: string;
    // state?: string;
    state?: State;
    postalCode?: string;
    activeStatus?: ActiveStatus;
    addressCountryId?: number;
    fullAddress?: string;
    fullAddressForMovers?: string;
    countryDTO?: any;
    telephoneCode?: number;
    telephoneCodeCountry?: ICountryMySuffix;
    telephoneCodeCountryId?: Number;
    telephoneNumber?: string;

    faxCode?: number;
    faxCodeCountry?: ICountryMySuffix;
    faxCodeCountryId?: Number;
    fax?: string;
}

export class AddressMySuffix implements IAddressMySuffix {
    constructor(
        public id?: number,
        public streetAddress?: string,
        public addressLine?: string,
        public city?: string,
        // public state?: string,
        public state?: State,
        public postalCode?: string,
        public activeStatus?: ActiveStatus,
        public addressCountryId?: number,
        public fullAddress?: string,
        public fullAddressForMovers?: string,
        public countryDTO?: any,
        public telephoneCode?: number,
        public telephoneCodeCountry?: ICountryMySuffix,
        public telephoneNumber?: string,
        public faxCode?: number,
        public faxCodeCountry?: ICountryMySuffix,
        public faxCodeCountryId?: Number,
        public fax?: string,
        public addressCountry?: any,

    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
    }
}

export class State {
    constructor(
        public id?: number,
        public name?: string,
        
    ) {
       
    }
}
